import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineRegionSelect from '../inputs/InlineRegionSelect';
import InlineInputNumber from '../inputs/InlineInputNumber';


const PercentBudgetSpent = (props) => {
  const {
    form, type, initialValues, onSubmit, ...other
  } = props;
  const initialState = {
    percent: initialValues.percent || 100,
    regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0],
  };

  const [percent, setPercent] = useState(initialState.percent);
  const [regions, setRegions] = useState(initialState.regions);

  const handleSubmit = useCallback((event) => {
    event.preventDefault();
    onSubmit({
      kind: 'percent_budget_spent',
      regions: _.filter(regions),
      value: { percent }
    });
  }, [onSubmit, percent, regions]);

  const onReset = useCallback(() => {
    setPercent(initialState.percent);
    setRegions(initialState.regions);
  }, [initialState]);

  return (
    <RuleForm
      {...other}
      onSubmit={handleSubmit}
      onReset={onReset}
      isSubmitting={form.is_submitting}
    >
      <InlineRegionSelect
        value={regions}
        onChange={setRegions}
      />
      <InlineInputNumber
        label='Percent Spent'
        description='What percentage of the budget has been spent'
        displayFormat='percent'
        value={percent}
        onChange={setPercent}
      />
    </RuleForm>
  );
};

PercentBudgetSpent.defaultProps = {
  type: 'add',
  initialValues: {}
};

PercentBudgetSpent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default PercentBudgetSpent;
